import { toast } from 'react-toastify';

const success = (msg: string) => toast.success(msg);
const error = (msg: string) => toast.error(msg);

export default { success, error };
